import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {  IOcbEnvironmentAccess, OcbFileTransferLogTypes, StatisticsService, UserService } from '@app/core';
import { TranslateService } from '@ngx-translate/core';
import { DxChartComponent } from 'devextreme-angular/ui/chart';
import notify from 'devextreme/ui/notify';

@Component({
    selector: 'app-home-statistics',
    templateUrl: './home-statistics.component.html',
    styleUrls: ['./home-statistics.component.scss'],
})
export class HomeStatisticsComponent implements AfterViewInit {

    @ViewChild('logs')
    public logsPieChart: DxChartComponent;

    // Main Data-Grid
    public dataSource: PieData[] = [];
    public dataSourceSum = 0;

    public environments: IOcbEnvironmentAccess[] = [];
    public selectedEnvironment: IOcbEnvironmentAccess;

    /**
     * Logs types labels in JSON object
     */
    private logsTypesLabels: any[];

    constructor(
        private route: ActivatedRoute,
        private userService: UserService,
        private statisticsService: StatisticsService,
        private translateService: TranslateService,
    ) {
    }

    public ngAfterViewInit() {
        this.userService.user.subscribe(admin => {
            this.environments = admin.environments.filter(env => env.canAccessLogs);
            if (this.environments.length > 0) {
                this.selectedEnvironment = this.environments.find(env => env.environmentId === this.userService.currentEnvironment);
            }
        });
        this.route.params.subscribe(_ => {
            this.translateService.get('fileTransfersLogTypes').subscribe(logTypes => {
                this.logsTypesLabels = logTypes;
                this.loadDataSource();
            });
        });
    }

    /**
     * Load data source with the current environments logs
     */
    public loadDataSource() {
        if (this.selectedEnvironment) {
            this.statisticsService.getFileTransfersStatistics(this.selectedEnvironment.environmentId)
                .subscribe({
                    next: (res) => {
                        this.dataSource = [];
                        this.dataSourceSum = 0;
                        for (const lt in OcbFileTransferLogTypes) {
                            if (Number(lt)) {
                                const filtered = res.filter(log => log.eventType === Number(lt));
                                if (filtered.length > 0) {
                                    this.dataSource.push({
                                        eventType: this.logsTypesLabels[OcbFileTransferLogTypes[lt]],
                                        count: filtered[0].count,
                                    });
                                    this.dataSourceSum += filtered[0].count;
                                }
                            }
                        }
                    },
                    error: (err) => {
                        this.handleError(err);
                    }
                });
        }
    }

    /**
     * Customize legend
     */
    public customizeLabel(point) {
        return point.argumentText + ": " + point.valueText;
    }

    /**
     * Displays error message in notification
     */
    private handleError(error: any): void {
        let message: '';
        if (error instanceof HttpErrorResponse) {
            if (error.error.hasOwnProperty('message')) {
                message = error.error.message;
            } else if (error.error.hasOwnProperty('name')) {
                message = error.error.name;
            } else {
                message = error.error;
            }
        } else {
            message = error;
        }

        notify(message, 'error', 3000);
    }
}

export interface PieData {
    eventType: string;
    count: number;
}
